import { PANEL } from '../utils/constants';

// Actions
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
const SET_LOADING = 'SET_LOADING';
const SET_PAGE = 'SET_PAGE';
const ERROR = 'ERROR';

const OPEN_DETAIL_PANEL = 'OPEN_DETAIL_PANEL';
const CLOSE_DETAIL_PANEL = 'CLOSE_DETAIL_PANEL';
const TOGGLE_CONFIRM_POPUP = 'TOGGLE_CONFIRM_POPUP';
const TOGGLE_SNACKBAR = 'TOGGLE_SNACKBAR';
const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
const CLEAR_SNACKBAR = 'CLEAR_SNACKBAR';

const initialState = {
  currentPage: '',
  modalOpen: {
    businessClient: false,
    [PANEL.CLEANER_TASK]: false,
    [PANEL.MAINTENANCE]: false,
    client: false,
    personnel: false,
    asset: false,
    assetType: false,
    patrols: false,
    visitor: false,
    profile: false,
    [PANEL.COMPANY_PROFILE]: false,
    transportServiceType: false,
    messaging: false,
    [PANEL.DEPARTMENTS]: false,
  },
  detailOpen: {
    distress: false,
  },
  error: undefined,
  loading: false,
  confirmPopup: {
    cancelTrip: false,
  },
  snackBar: {
    type: '',
    open: false,
    message: '',
    position: { vertical: 'top', horizontal: 'right' },
    autoHideDuration: 3000,
  },
  refreshDashboardUI: false,
};
// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TOGGLE_MODAL:
      return {
        ...state,
        modalOpen: {
          ...state.modalOpen,
          [action.location]: !state.modalOpen[action.location],
        },
      };
    case ERROR:
      return {
        ...state,
        error: action.error,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    case SET_PAGE:
      return {
        ...state,
        currentPage: action.location,
      };

    case OPEN_DETAIL_PANEL:
      return {
        ...state,
        detailOpen: { ...state.detailOpen, [action.location]: true },
      };

    case CLOSE_DETAIL_PANEL:
      return {
        ...state,
        detailOpen: { ...state.detailOpen, [action.location]: false },
      };
    case TOGGLE_CONFIRM_POPUP:
      return {
        ...state,
        confirmPopup: {
          ...state.confirmPopup,
          [action.location]: !state.confirmPopup[action.location],
        },
      };
    case SHOW_SNACKBAR:
      return {
        ...state,
        snackBar: {
          ...state.snackBar,
          open: true,
          type: action.typeOfSnackbar,
          autoHideDuration:
            action.autoHideDuration || initialState.snackBar.autoHideDuration,
          position: action.position || initialState.snackBar.position,
          message: action.message,
        },
      };
    case CLEAR_SNACKBAR:
      return {
        ...state,
        snackBar: initialState.snackBar,
      };
    // do reducer stuff
    default:
      return state;
  }
}

// Action Creators
export function updatePage(location) {
  return { type: SET_PAGE, location };
}

export function resetError() {
  return { type: ERROR, error: undefined };
}

export function toggleModal(location) {
  return { type: TOGGLE_MODAL, location };
}

export function createError(error) {
  return { type: ERROR, error };
}

export function removeError() {
  return { type: ERROR, error: undefined };
}

export function setLoading(loading) {
  return { type: SET_LOADING, loading };
}

export function openDetails(location) {
  return { type: OPEN_DETAIL_PANEL, location };
}

export function closeDetails(location) {
  return { type: CLOSE_DETAIL_PANEL, location };
}
export function toggleConfirmPopup(location) {
  return { type: TOGGLE_CONFIRM_POPUP, location };
}
export function toggleSnackBar() {
  return { type: TOGGLE_SNACKBAR };
}
export function clearSnackbar() {
  return { type: CLEAR_SNACKBAR };
}
export function showSnackbar({
  typeOfSnackbar,
  message,
  autoHideDuration,
  position,
}) {
  return {
    type: SHOW_SNACKBAR,
    typeOfSnackbar,
    message,
    autoHideDuration,
    position,
  };
}

// Selectors
export const getCurrentPage = state => state.router.location.pathname;
export const getError = state => state.ui.error;
export const modalState = state => state.ui.modalOpen;
export const detailOpenState = state => state.ui.detailOpen;
export const getLoadingState = state => state.ui.loading;
export const snackBarConfig = state => state.ui.snackBar;
export const getDashboardRefreshKey = state => state.ui.refreshDashboardUI;
